import { render, staticRenderFns } from "./MyHome.vue?vue&type=template&id=db0ff3ec&scoped=true"
import script from "./MyHome.vue?vue&type=script&lang=js"
export * from "./MyHome.vue?vue&type=script&lang=js"
import style0 from "./MyHome.vue?vue&type=style&index=0&id=db0ff3ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db0ff3ec",
  null
  
)

export default component.exports